import { InputsTable } from 'components/InputsTable'
import type { InputType } from 'config'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getAdminConfig, setAdminConfig } from 'services'
import { svgLoading } from 'stories/assets'

const templateInputs: Record<string, InputType> = {
  title: {
    inputType: 'text',
    title: 'Title',
    required: true,
  },
  description: {
    inputType: 'textarea',
    title: 'Description',
    required: true,
    rows: 3,
  },
}

const CONFIG_KEY = 'taskTemplate'

export const TaskTemplates = () => {
  const [isLoading, setLoading] = useState(true)
  const [rows, setRows] = useState<Record<string, any>[]>([])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setLoading(true)
    try {
      const data = await getAdminConfig(CONFIG_KEY)
      setRows(Array.isArray(data) ? data : [])
    } catch {
      toast('Failed to load task templates.', { type: 'error' })
    } finally {
      setLoading(false)
    }
  }

  const onUpdate = async (nextRows: Record<string, any>[]) => {
    setRows(nextRows)
    try {
      await setAdminConfig(CONFIG_KEY, nextRows as any)
      toast('Task templates saved.', { type: 'success' })
    } catch {
      toast('Failed to save task templates.', { type: 'error' })
    }
  }

  return (
    <div className="TaskTemplates-container relative">
      <h2 className="text-2xl font-bold flex items-center mb-3">
        Task Comment Templates
        {isLoading && (
          <span className="ml-3">
            <img src={svgLoading} className="inline w-6 h-6 text-white animate-spin" />
          </span>
        )}
      </h2>

      <InputsTable
        title="Templates"
        inputs={templateInputs}
        rows={rows}
        onUpdate={onUpdate}
        columnKeys={['title', 'description']}
        addRowTitle="Add Template"
        editRowTitle="Edit Template"
        confirmRemoveMessage="Are you sure you want to remove this template?"
        formClassName="w-196 grid gap-4 grid-cols-1 text-sm"
      />
    </div>
  )
}
